import { client } from '../../../../../common-utils/libraries/axios/axios';
import { replaceParameters } from '../../../../../common-utils/functions/restUtils';
import { PLANS } from '../apiUrls';
import plansFields from '../../fields/plansFields';
import generateNestedFieldAccessor from '@/common-utils/functions/generateNestedFieldAccessor';
import getObjectAttributeFromStringKey from '@/common-utils/functions/getObjectAttributeFromStringKey';
/**
 * @param root0 response.data object
 * @param root0.uuid
 * @param root0.shouldAutoActivateSubscriptions
 * @param root0.label
 * @param root0.producCode
 * @param root0.ownerOrganization
 * @param root0.parentSubscriptionPlan.uuid
 * @param root0.parentSubscriptionPlan.label
 * @param root0.allowedClients
 * @param root0.createdAt
 * @param root0.updatedAt
 * @param root0.pushPaymentEmitterPartners
 * @param response
 * @returns Mapped data object
 */
function mapResponseData(response) {
    const data = {};

    data[plansFields.UUID.key] = response[plansFields.UUID.key];
    data[plansFields.ALLOWED_CLIENTS.key] = response[plansFields.ALLOWED_CLIENTS.key];
    data[plansFields.CREATED_AT.key] = response[plansFields.CREATED_AT.key];
    data[plansFields.LABEL.key] = response[plansFields.LABEL.key];
    data[plansFields.OWNER_ORGANIZATION.key] = response[plansFields.OWNER_ORGANIZATION.key];
    data[plansFields.PARENT_SUBSCRIPTION_PLAN.key] = response[plansFields.PARENT_SUBSCRIPTION_PLAN.key] && {
        [plansFields.PARENT_SUBSCRIPTION_PLAN.LABEL.key]:
            getObjectAttributeFromStringKey(response, generateNestedFieldAccessor(plansFields.PARENT_SUBSCRIPTION_PLAN.LABEL)),
        [plansFields.PARENT_SUBSCRIPTION_PLAN.UUID.key]:
            getObjectAttributeFromStringKey(response, generateNestedFieldAccessor(plansFields.PARENT_SUBSCRIPTION_PLAN.UUID))
    };
    data[plansFields.PRODUCT_CODE.key] = response[plansFields.PRODUCT_CODE.key];
    data[plansFields.SHOULD_AUTO_ACTIVATE_SUBSCRIPTIONS.key] = response[plansFields.SHOULD_AUTO_ACTIVATE_SUBSCRIPTIONS.key]; //parent keys
    data[plansFields.UPDATED_AT.key] = response[plansFields.UPDATED_AT.key];

    return data;
}

const queryGetPlan = ({ organizationId, planId }, enabled) => {
    return {
        queryKey: [PLANS.DETAILS.queryKey, organizationId, planId],
        queryFn: async () => {
            const response = await client.get(replaceParameters(PLANS.DETAILS.url, { organizationId: organizationId, planId: planId }));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetPlan;